import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrSwitch from '../components/FrSwitch'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function RegTipoDocumento() {
  const [data, setData] = useState({ativo: 'S'})
  const [updateType, setUpdateType] = useState(false)
  const [comboModelo, setComboModelo] = useState([{value: '', display: ''}])
  const [comboOrgao, setComboOrgao] = useState([{value: '', display: ''}])
  const [enableEdit, setEnableEdit] = useState('N')

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      setComboModelo(await api.getComboData('modelo_documento'))
      setComboOrgao(await api.getComboData('orgao'))

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Tipo de Documento', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Tipo de Documento', 'Inclusao'))
      }

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/tipo_documento?pk_tdo=' + query.codigo).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setData(r.data[0])
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/tipo_documento/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alteraddo',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/tipo_documento/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'exige_numero':
      case 'exige_validade':
      case 'exige_revalidacao':
        auxValues[e.target.name] = e.target.checked ? 'S' : 'N'
      break

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Tipo de Documento</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='50'
            value={data.descricao || ''}
            onChange={handleChange}
            name="descricao"
            id="descricao"
            color="#9c9595"
            label="Descrição"
            variant="outlined"
            size="small"
            required
            style={{ width: 330 }}
          />
          <FrSelect 
            value={data.ativo || []} 
            style={{width: 100}} 
            name="ativo" 
            id="ativo" 
            label='Ativo' 
            data={[{ display: 'Sim', value: 'S' }, { display: 'Não', value: 'N' }]}
            onChange={handleChange}
          />
          <br/>
          <br/>
          <FrSelect 
            value={data.fk_mdl || []} 
            style={{ flex: 1, minWidth: '200px'}} 
            name="fk_mdl" 
            id="fk_mdl" 
            label='Modelo' 
            data={comboModelo}
            onChange={handleChange}
          />
          <FrSwitch
            checked={(data.exige_numero||null) === 'S'} 
            name="exige_numero" 
            id="exige_numero" 
            label='Número' 
            onChange={handleChange}
          /> 
          <FrSwitch
            checked={(data.exige_validade||null) === 'S'} 
            name="exige_validade" 
            id="exige_validade" 
            label='Validade' 
            onChange={handleChange}
          /> 
          <FrSwitch
            checked={(data.exige_revalidacao||null) === 'S'} 
            name="exige_revalidacao" 
            id="exige_revalidacao" 
            label='Revalidação' 
            onChange={handleChange}
          />
          <br/>
          <FrTextInput
            maxLength='50'
            value={data.dias_prazo_ideal || ''}
            onChange={handleChange}
            name="dias_prazo_ideal"
            id="dias_prazo_ideal"
            color="#9c9595"
            label="Prazo Ideal"
            variant="outlined"
            size="small"
            type="number"
            required
            style={{ width: 120 }}
          />
          <FrTextInput
            maxLength='50'
            value={data.dias_prazo_limite || ''}
            onChange={handleChange}
            name="dias_prazo_limite"
            id="dias_prazo_limite"
            color="#9c9595"
            label="Prazo Limite"
            variant="outlined"
            size="small"
            type="number"
            required
            style={{ width: 120 }}
          />
          <br/>
          <br/>
          <FrSelect 
            value={data.fk_org || []} 
            style={{ flex: 1, minWidth: '200px'}} 
            name="fk_org" 
            id="fk_org" 
            label='Orgão' 
            data={comboOrgao}
            onChange={handleChange}
          />
        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RegTipoDocumento;
